var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Spinner',{staticClass:"fill-current",class:[
    _vm.mode,
    { 'w-12 h-12': _vm.size === 'default', 'w-5 h-5': _vm.size === 'small' } ]})}
var staticRenderFns = []

export { render, staticRenderFns }